.customer-lead-step-purchase-items-tab__container {
  flex: 1;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 32px;

  padding: 24px 0 0;
}

.customer-lead-step-purchase-items-tab__container .customer-lead-step-purchase-items-tab__container__row {
  width: 100%;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}
